import { action } from "../../modules/presence/actions/actionCreator";
import { GET_ABSENCE_TYPES } from "./../../modules/presence/actions/presence";

export const getAbsenceTypes = () => {
  return action(GET_ABSENCE_TYPES, {});
};



// WEBPACK FOOTER //
// src/redux/actions/absenceTypesActions.js